import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  IconButton,
  InputAdornment,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import TextField from './TextField';

const styles = () => ({
  adornedEnd: {
    padding: 0,
  },
});

const PasswordField = ({
  type,
  classes,
  ...rest
}) => {
  const [values, setValues] = React.useState({
    password: '',
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  return (
    <TextField
      type={values.showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="Toggle password visibility"
              onClick={handleClickShowPassword}
            >
              {values.showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        classes: { adornedEnd: classes.adornedEnd },
      }}
      {...rest}
    />
  );
};

PasswordField.propTypes = {
  type: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

PasswordField.defaultProps = {
  type: '',
};

export default withStyles(styles)(PasswordField);
